import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import LoginPage from "./pages/auth/Login";
import DashboardPage from "./pages/dashboard/Dashboard";
import DevelopmentPage from "./pages/development/Development";
import ReportPage from "./pages/reports/Report";
import ReportsList from "./pages/reports/ReportsList";
import { KeycloakProvider } from "./pages/auth/KeycloakContext";
import ErrorBoundary from "./pages/auth/ErrorBoundary";
import AuthCallbackPage from "./pages/auth/AuthCallback";
import { useKeycloak } from "./pages/auth/auth.hooks";
import Spinner from "./components/Spinner";

function AuthenticatedRoute(props) {
  const { authenticated, keycloak, initialized, admin } = useKeycloak();

  if (!initialized) {
    return <Spinner isFullScreen={true} />;
  }

  if (!authenticated) {
    keycloak.login();
    return <Spinner isFullScreen={true} />;
  }

  if (props.isAdmin && !admin) {
    return <Redirect to="/dashboard" />;
  }

  return props.children;
}

function RouterContainer() {
  return (
    <Router>
      <ErrorBoundary>
        <Switch>
          <Route path="/auth/callback" exact>
            <AuthCallbackPage />
          </Route>
          <Route path="/" exact>
            <Redirect to="/dashboard" />
          </Route>
          <Route path="/auth/login" exact>
            <LoginPage />
          </Route>
          <Route path="/dashboard" exact>
            <AuthenticatedRoute>
              <DashboardPage path="/dashboard" />
            </AuthenticatedRoute>
          </Route>
          <Route path="/dev" exact>
            <AuthenticatedRoute isAdmin>
              <DevelopmentPage path="/dev" />
            </AuthenticatedRoute>
          </Route>
          <Route path="/list" exact>
            <AuthenticatedRoute isAdmin>
              <ReportsList path="/list" />
            </AuthenticatedRoute>
          </Route>
          <Route path="/reports/:reportKey" exact>
            <AuthenticatedRoute>
              <ReportPage path="/reports" />
            </AuthenticatedRoute>
          </Route>
          <Route path="/apportionments/:reportKey" exact>
            <AuthenticatedRoute>
              <ReportPage path="/apportionments" />
            </AuthenticatedRoute>
          </Route>
          <Route path="/tools/:reportKey" exact>
            <AuthenticatedRoute>
              <ReportPage path="/tools" />
            </AuthenticatedRoute>
          </Route>
        </Switch>
      </ErrorBoundary>
    </Router>
  );
}

function App() {
  return (
    <KeycloakProvider>
      <RouterContainer />
    </KeycloakProvider>
  );
}

export default App;
